import React from "react"

import { Input, Card, Divider, Checkbox, Segment } from "semantic-ui-react"
import styled, { css } from "styled-components"

const Section = ({ title, children, largeTitle }) => {
  return (
    <Card fluid>
      <Card.Content>
        <CenteredText>
          {largeTitle ? <h3>{title}</h3> : <h4>{title}</h4>}
        </CenteredText>
        {children}
      </Card.Content>
    </Card>
  )
}

const FormESF = () => {
  return (
    <>
      <Section title="ЭЛЕКТРОННЫЙ СЧЕТ-ФАКТУРА" largeTitle={true}>
        <Divider />

        <Section title="Раздел А. Общий раздел">
          <Flex>
            <InputWrap>
              <p>1. Регистрационный номер</p>
              <Input value="ESF-050540001669-20200407-48554197" />
            </InputWrap>

            <InputWrap>
              <p>1.1. Номер учетной системы</p>
              <Input value="00000000196" />
            </InputWrap>

            <InputWrap width={106}>
              <p>2. Дата выписки</p>
              <Input value="07.04.2020" />
            </InputWrap>

            <InputWrap>
              <p>2.1. Дата выписки на бумажном носителе</p>
              <Input />
            </InputWrap>

            <InputWrap>
              <p>3. Дата совершения оборота</p>
              <Input value="31.03.2020" />
            </InputWrap>
          </Flex>

          <Flex>
            <InputWrap>
              <Flex>
                4. Исправленный <Checkbox />
              </Flex>
            </InputWrap>
            <InputWrap>4.1. Дата</InputWrap>
          </Flex>
        </Section>
        <Section title="Раздел B. Реквизиты поставщика"></Section>
        <Section title="Раздел B1. Банковские реквизиты поставщик"></Section>
        <Section title="Раздел C. Реквизиты получател"></Section>
        <Section title="Раздел D. Реквизиты грузоотправителя и грузополучателя"></Section>
        <Section title="Раздел Е. Договор (контракт)"></Section>

        <Section title="Раздел F. Реквизиты документов, подтверждающих поставку товаров, работ, услуг "></Section>
        <Section title="Раздел G. Данные по товарам, работам, услугам"></Section>
        <Section title="Раздел L. Сведения по ЭЦП"></Section>
      </Section>
    </>
  )
}

const CenteredText = styled.div`
  text-align: center;
`
const Flex = styled.div`
  display: flex;
`

const InputWrap = styled.div`
  padding: 5px 3px;

  .ui.input {
    width: ${({ width }) => (width ? `${width}px` : "100%")};
  }

  input {
    margin-left: 5px !important;
  }
`

export default FormESF
